import { CtaWidget } from './CtaWidget'
import { DrawerWidget } from './DrawerWidget'
import { InitializerWidget } from './InitializerWidget'
import { LegacyCtaWidget } from './LegacyCtaWidget'
import { MyClaimsWidget } from './MyClaimsWidget'
import { OverviewWidget } from './OverviewWidget'
import { StatusWidget } from './StatusWidget'
import { ToggleWidget } from './ToggleWidget'
import { initWidgetEventListener } from './util/widgetEventListener'
import { createBasicWidgetHolder, createWidgetHolder } from './widgetHolder'

const INITIALIZER_WIDGET_CONTAINER_ID = 'directBilling-initializer'

/**
 * Initialize widgets and make them available on window.directBilling object.
 * Each widget is independently rendered on the commerce F/E app.
 *
 * All widgets share the same global redux state. However, some widgets may
 * need to communicate with other widgets thru custom events. e.g. the ctaWidget
 * cannot directly render the drawer so it has to use the custom events.
 *
 * Note: the dbWidget contains the cta and the drawer and suits flows where the
 * cta and drawer are rendered on specific pages (CLE, VDE).
 *
 * For flows where the drawer needs to be rendered from every page, the toggleWidget
 * and drawerWidget must be used (NUA).
 */

const dbWidget = createWidgetHolder(LegacyCtaWidget, 'directbilling-main', '#insuranceApp')
const ctaWidget = createWidgetHolder(CtaWidget, 'directbilling-cta', '#insuranceCtaApp')
const drawerWidget = createWidgetHolder(DrawerWidget, 'directbilling-drawer', '#insuranceDrawerApp')
const toggleWidget = createWidgetHolder(ToggleWidget, 'directbilling-toggle', '#insuranceToggleApp')
const statusWidget = createWidgetHolder(StatusWidget, 'directbilling-status', '#insuranceStatusApp')
const overviewWidget = createWidgetHolder(OverviewWidget, 'directbilling-overview', '#insuranceOverviewApp')
const myClaimsWidget = createWidgetHolder(MyClaimsWidget, 'directbilling-myclaims', '#insuranceMyClaimsApp')

window.directBilling = {
  dbWidget,
  ctaWidget,
  drawerWidget,
  statusWidget,
  toggleWidget,
  overviewWidget,
  myClaimsWidget,
  env: {},
}

const initWidgets = () => {
  initWidgetEventListener()

  // render internal initializer widget
  const selector = createInitializerWidgetContainer()
  const widgetHolder = createBasicWidgetHolder(InitializerWidget)
  widgetHolder.new({ selector }).render()
}

const createInitializerWidgetContainer = (): string => {
  let container = document.getElementById(INITIALIZER_WIDGET_CONTAINER_ID) as HTMLDivElement
  if (!container) {
    container = Object.assign(document.createElement('div'), {
      id: INITIALIZER_WIDGET_CONTAINER_ID,
    })
    document.body.append(container)
  }
  return `#${INITIALIZER_WIDGET_CONTAINER_ID}`
}

export default initWidgets
